import { Box, Grid, Image, Text } from '@joinrepublic/dls-ui-kit';

import { IBusinessRowData } from './eu-businesses-query';

export interface ISecondaryMarketRowProps {
  deal: IBusinessRowData;
}

export const SecondaryMarketRow = ({
  deal: { logo, name, performance, valuation },
}: ISecondaryMarketRowProps) => {
  return (
    <Grid
      data-testid="secondary-market-row"
      templateColumns={{
        base: 'max-content auto max-content 12%',
        lg: 'max-content auto max-content 15%',
      }}
      alignItems="center"
      gap={{ base: '4', sm: '5', lg: '7' }}
      py={{ base: '3', sm: '5' }}
      boxShadow="0 1px 0 0 rgb(0 0 0 / 7%)"
    >
      <Box
        as="figure"
        w="fit-content"
        boxShadow="inset 0 0 0 1px rgb(0 0 0 / 7%)"
        borderRadius="base"
        overflow="hidden"
      >
        <Image
          src={logo}
          alt={`${name} logo`}
          boxSize={{ base: '8', sm: '10', lg: '14' }}
          objectFit="contain"
          position="relative"
          zIndex="-1"
        />
      </Box>
      <Text size={{ base: 'body-sm', sm: 'body-md', lg: 'body-lg' }}>
        {name}
      </Text>
      <Text
        size={{ base: 'body-xs', sm: 'body-md' }}
        color={performance.startsWith('+') ? 'green.500' : 'grey.500'}
        whiteSpace="nowrap"
      >
        {performance}
      </Text>
      <Text
        size={{ base: 'body-xs', sm: 'body-md' }}
        textAlign="right"
        whiteSpace="nowrap"
      >
        {valuation}
      </Text>
    </Grid>
  );
};
